import { render, staticRenderFns } from "./SearchedProduct.vue?vue&type=template&id=3660f089&scoped=true&"
import script from "./SearchedProduct.vue?vue&type=script&lang=js&"
export * from "./SearchedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SearchedProduct.vue?vue&type=style&index=0&id=3660f089&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660f089",
  null
  
)

export default component.exports